import { useQuery } from '@tanstack/react-query';
import { useChatApiClient } from '@trinity/chat-components/containers/Chat/useApiClient';
import * as atlas from 'azure-maps-control';
import { Map } from './AzureMap';

export type BaseAzureMapProps = {
  dataSourceId: string;
  features: Feature[];
  layers: atlas.layer.Layer[];
  mapOptions?: atlas.CameraOptions;
  height?: string;
  width?: string;
};

export const AzureMap = (props: BaseAzureMapProps) => {

  const apiClient = useChatApiClient();

  const q = useQuery({
    queryKey: ['mapData', props.dataSourceId],
    queryFn: () => {
      return apiClient.location.getAzureMapsConfig();
    },
  });

  if (q.isLoading) {
    return null;
  }

  return (
    <Map {...props} azureMapsClientId={q.data.azureMapsClientId} />
  );
};

type Feature = atlas.data.FeatureCollection | atlas.data.Feature<atlas.data.Geometry, unknown> | atlas.data.Geometry | atlas.data.GeometryCollection | atlas.Shape;